import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { ExternalSettings } from '../../services/external-settings/external-settings.interface';
import { ResponsiveDesignService } from '../../services/responsive-design/responsive-design.service';

@Component({
    selector: 'app-me-error-dialog',
    templateUrl: './me-error-dialog.component.html',
    styleUrls: ['./me-error-dialog.component.less'],
    standalone: false
})
export class MeErrorDialogComponent implements OnInit {
  UIUtilityService: any = UIUtilityService;
  externalSettings!: ExternalSettings;

  constructor(
    private srvES: ExternalSettingsService,
    public dialogRef: MatDialogRef<MeErrorDialogComponent>,
    protected srvRpDesign: ResponsiveDesignService,
    @Inject(MAT_DIALOG_DATA) public data: ErrorDialog
  ) {
  }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((settings) => {
      this.externalSettings = settings;
    });
  }
}

export interface ErrorDialog {
  title: string;
  msgs: string[];
  buttonText: string;
  image?: string;
}
